import { notification } from "antd";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { NO_PERMISSION_MESSAGE } from "../const/ConstData";
import PermissionAccess from "../utils/Permission";
import { GetToken } from "../utils";

// Logged-in user's role permissions (see utils/Permission.js)
export const useAccess = () => useSelector((state) => state.common.access);

/**
 * Page guard: returns true when the user has `type` (List/Add/Edit/Delete) on
 * `module`, otherwise redirects to the No Permission page. Waits until the
 * permissions have loaded so a page refresh does not bounce the user.
 */
export const usePermission = (module, type) => {
    const navigate = useNavigate();
    const access = useAccess();
    const allowed = !GetToken() || (access.loaded && !!PermissionAccess(module, access)[type]);

    useEffect(() => {
        if (GetToken() && access.loaded && !allowed) {
            navigate("/no-permission", { replace: true });
            notification.destroy();
            notification["error"]({
                message: NO_PERMISSION_MESSAGE
            });
        }
    }, [access.loaded, allowed]);

    return allowed;
};

// { List, Add, Edit, Delete } for showing or hiding buttons inside a page
export const useRights = (module) => PermissionAccess(module, useAccess());
